import React, { Fragment, Component } from "react";
import { withRouter } from "react-router";
import {
  Col,
  Container,
  Row,
  Spinner,
  Card,
  CardBody,
  Button,
} from "reactstrap";
import IndexBloc from "../Blocs/IndexBloc";
import { Bar } from "react-chartjs-2";
import apiResponse from "../../../../../services/apiResponse";
import {
  Document,
  Packer,
  Paragraph,
  ImageRun,
  TextRun,
  AlignmentType,
} from "docx";
import { saveAs } from "file-saver";
import image from "../../../../../assets/images/BKPM NEW 1.png";

class IndexView extends Component {
  indexBloc = new IndexBloc();

  constructor(props) {
    super(props);
    this.chartRef = React.createRef();
    this.state = {
      data: null,
      dataHistory: null,
      loading: false,
      hoveredDesc: false,
      errorMessage: null,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    this.setState({ loading: true, errorMessage: null });

    this.indexBloc.getAllNetworkTraffic6MonthChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          let response = result.data.response;
          let errormessage = result.data.message;
          this.setState({
            data: response,
            loading: false,
            errorMessage: errormessage,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            errorMessage: "Failed to load data. Please try again.",
          });
          break;
        default:
          break;
      }
    });

    this.indexBloc.fetchAllGraphNetworkTrafficNow6Month({});

    this.indexBloc.getAllNetworkTraffic6MonthHistoryChannel.subscribe(
      (result) => {
        switch (result.status) {
          case apiResponse.COMPLETED:
            let response = result.data.response;
            this.setState({
              dataHistory: response,
              loading: false,
            });
            break;
          case apiResponse.ERROR:
            this.setState({
              loading: false,
            });
            break;
          default:
            break;
        }
      }
    );

    this.indexBloc.fetchAllGraphNetworkTrafficNow6MonthHistory({});
  };

  // createChart = () => {
  //   const { selectedHost } = this.props;
  //   const { dataHistory } = this.state;

  //   const defaultChartData = {
  //     labels: [],
  //     datasets: [],
  //   };

  //   if (!selectedHost) {
  //     return defaultChartData;
  //   }

  //   const value = selectedHost.value;

  //   const specificHost = Array.isArray(dataHistory)
  //     ? dataHistory.find((item) => item.host.hostid === value)
  //     : null;

  //   const graphId = specificHost ? specificHost.graph.graphid : null;

  //   const specificGraph = Array.isArray(this.state.dataHistory)
  //     ? this.state.dataHistory.find((item) => item.graph.graphid === graphId)
  //     : null;

  //   const items =
  //     specificGraph && Array.isArray(specificGraph.graph.items)
  //       ? specificGraph.graph.items
  //       : [];

  //   const convertToKbps = (value) => {
  //     if (value.includes("Mbps")) {
  //       return parseFloat(value.replace(" Mbps", "")) * 1000;
  //     } else if (value.includes("Kbps")) {
  //       return parseFloat(value.replace(" Kbps", ""));
  //     }
  //     return parseFloat(value.replace(" bps", "")) / 1000;
  //   };

  //   const predefinedColors = [
  //     "rgba(0, 130, 0, 0.8)",
  //     "rgba(214, 68, 0, 0.8)",
  //     "rgba(0, 238, 0, 0.8)",
  //     "rgba(255, 176, 0, 0.8)",
  //     "rgba(255, 24, 169, 0.8)",
  //     "rgba(137, 8, 241, 0.8)",
  //   ];

  //   const labels =
  //     items.length > 0 ? items[0].values.map((v) => v.timestamp) : [];

  //   const datasets = items.map((item, index) => {
  //     const color = predefinedColors[index % predefinedColors.length];
  //     const data =
  //       Array.isArray(item.values) && item.values.length > 0
  //         ? item.values.map((v) => convertToKbps(v.last))
  //         : [];
  //     return {
  //       label: item.name,
  //       data: data,
  //       backgroundColor: color,
  //       borderColor: color.replace("0.8", "1"),
  //       borderWidth: 1,
  //     };
  //   });

  //   const graph = {
  //     labels,
  //     datasets,
  //   };

  //   const options = {
  //     responsive: true,
  //     scales: {
  //       y: {
  //         beginAtZero: true,
  //         title: {
  //           display: true,
  //           text: "Kbps",
  //         },
  //       },
  //     },
  //   };

  //   return { graph, options };
  // };

  createChart = () => {
    const { selectedHost } = this.props;
    const { dataHistory } = this.state;

    const defaultChartData = {
      labels: [],
      datasets: [],
    };

    if (!selectedHost) {
      return defaultChartData;
    }

    const value = selectedHost.value;

    const specificHost = Array.isArray(dataHistory)
      ? dataHistory.find((item) => item.host.hostid === value)
      : null;

    const graphId = specificHost ? specificHost.graph.graphid : null;

    const specificGraph = Array.isArray(this.state.dataHistory)
      ? this.state.dataHistory.find((item) => item.graph.graphid === graphId)
      : null;

    const items =
      specificGraph && Array.isArray(specificGraph.graph.items)
        ? specificGraph.graph.items
        : [];

    const convertToKbps = (value) => {
      if (value.includes("Mbps")) {
        return parseFloat(value.replace(" Mbps", "")) * 1000;
      } else if (value.includes("Kbps")) {
        return parseFloat(value.replace(" Kbps", ""));
      }
      return parseFloat(value.replace(" bps", "")) / 1000;
    };

    const predefinedColors = [
      "rgba(0, 130, 0, 0.8)",
      "rgba(214, 68, 0, 0.8)",
      "rgba(0, 238, 0, 0.8)",
      "rgba(255, 176, 0, 0.8)",
      "rgba(255, 24, 169, 0.8)",
      "rgba(137, 8, 241, 0.8)",
    ];

    const datasets = items.map((item, index) => {
      const color = predefinedColors[index % predefinedColors.length];
      const data =
        Array.isArray(item.values) && item.values.length > 0
          ? item.values.map((v) => convertToKbps(v.last))
          : [];
      return {
        label: item.name,
        data: data,
        backgroundColor: color,
        borderColor: color.replace("0.8", "1"),
        borderWidth: 1,
      };
    });

    const labels = (() => {
      if (items.length === 0 || items[0].values.length === 0) {
        return [];
      }

      const values = items[0].values;
      const groupedByMonth = {};

      values.forEach((value, index) => {
        const date = new Date(value.timestamp);
        const monthYear = `${date.getFullYear()}-${date.getMonth()}`;
        if (!groupedByMonth[monthYear]) {
          groupedByMonth[monthYear] = [];
        }
        groupedByMonth[monthYear].push(index);
      });

      const labels = values.map(() => "");
      Object.keys(groupedByMonth).forEach((monthYear) => {
        const indices = groupedByMonth[monthYear];
        const middleIndex = indices[Math.floor(indices.length / 2)];
        const date = new Date(values[middleIndex].timestamp);
        labels[middleIndex] = date.toLocaleDateString("id-ID", {
          month: "short",
        });
      });

      return labels;
    })();

    const graph = {
      labels,
      datasets,
    };

    const options = {
      responsive: true,
      scales: {
        y: {
          beginAtZero: true,
          title: {
            display: true,
            text: "Kbps",
          },
        },
      },
    };

    return { graph, options };
  };

  renderNetworkInfo = () => {
    const { selectedHost } = this.props;
    const { data, dataHistory } = this.state;

    if (!selectedHost) {
      return <div>Tidak ada host yang dipilih.</div>;
    }

    const value = selectedHost.value;

    const specificHost = Array.isArray(data)
      ? data.find((item) => item.host.hostid === value)
      : null;

    const graphId = specificHost ? specificHost.graph.graphid : null;

    const specificGraph = Array.isArray(data)
      ? data.find((item) => item.graph.graphid === graphId)
      : null;

    const items =
      specificGraph && Array.isArray(specificGraph.graph.items)
        ? specificGraph.graph.items
        : [];

    if (items.length === 0) {
      return <div>Tidak ada informasi tersedia untuk host yang dipilih.</div>;
    }

    const specificHistory = Array.isArray(dataHistory)
      ? dataHistory.find((history) => history.graph.graphid === graphId)
      : null;

    const historyItems =
      specificHistory && Array.isArray(specificHistory.graph.items)
        ? specificHistory.graph.items
        : [];

    if (historyItems.length === 0) {
      return <div>Tidak ada informasi tersedia untuk host yang dipilih.</div>;
    }

    return (
      <div>
        <div>
          <div style={{ fontWeight: "bold", fontSize: "20px" }}>
            Informasi{" "}
            <span
              className="uil-info-circle"
              onMouseEnter={() => this.setState({ hoveredDesc: true })}
              onMouseLeave={() => this.setState({ hoveredDesc: false })}
              style={{ cursor: "pointer" }}
            />
          </div>
          <br />
        </div>
        {this.state.hoveredDesc && (
          <div
            style={{
              position: "absolute",
              background: "#f4f4f4",
              border: "1px solid #ccc",
              borderRadius: "8px",
              padding: "10px",
              zIndex: 1000,
              width: "1000px",
              boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
            }}
          >
            {/* {this.renderNetworkDescriptions()} */}
            {items.length === 2
              ? this.renderDescriptionsTwo()
              : this.renderNetworkDescriptions()}
          </div>
        )}

        {items.map((item, index) => {
          const historyItem = historyItems.find(
            (history) => history.itemid === item.itemid
          );

          const last = item.last !== null ? item.last : "0.00 bps";
          const min =
            historyItem && historyItem.min ? historyItem.min : "0.00 bps";
          const max =
            historyItem && historyItem.max ? historyItem.max : "0.00 bps";
          const average =
            historyItem && historyItem.average
              ? historyItem.average
              : "0.00 bps";

          return (
            <div key={index}>
              <strong>{item.name}</strong> : <strong>Last:</strong> {last}{" "}
              <strong>|</strong> <strong>Min:</strong> {min} <strong>|</strong>{" "}
              <strong>Average:</strong> {average} <strong>|</strong>{" "}
              <strong>Max:</strong> {max}
            </div>
          );
        })}
      </div>
    );
  };

  renderNetworkDescriptions = () => {
    const { selectedHost } = this.props;
    const { data } = this.state;

    const value = selectedHost.value;

    const specificHost = Array.isArray(data)
      ? data.find((item) => item.host.hostid === value)
      : null;

    const graphId = specificHost ? specificHost.graph.graphid : null;

    const specificGraph = Array.isArray(this.state.data)
      ? this.state.data.find((item) => item.graph.graphid === graphId)
      : null;

    const items =
      specificGraph && Array.isArray(specificGraph.graph.items)
        ? specificGraph.graph.items
        : [];

    const desc = [
      {
        description:
          "Metrik ini menunjukkan jumlah paket data yang diterima oleh antarmuka jaringan namun dibuang sebelum diproses lebih lanjut.",
      },
      {
        description:
          "Metrik ini mengukur jumlah paket yang masuk ke antarmuka yang mengalami kesalahan, seperti bit error, framing error, atau masalah lainnya yang membuat paket tidak dapat diproses dengan benar.",
      },
      {
        description:
          "Metrik ini memberikan gambaran tentang seberapa banyak data yang masuk melalui antarmuka jaringan dalam suatu periode waktu tertentu.",
      },
      {
        description:
          "Metrik ini menunjukkan jumlah paket yang dikirim melalui antarmuka yang dibuang sebelum benar-benar dikirim ke tujuan.",
      },
      {
        description:
          "Ini mengukur jumlah paket yang dikirim melalui antarmuka yang mengalami kesalahan dalam proses pengiriman, seperti kesalahan sinyal atau masalah dalam lapisan fisik jaringan, sehingga paket tersebut tidak dapat dikirim dengan benar.",
      },
      {
        description:
          "Metrik yang menunjukkan jumlah data yang dikirim melalui antarmuka dalam bentuk bit per detik (bps).",
      },
    ];

    return (
      <div>
        {items.map((item, index) => (
          <div key={index}>
            <strong>{item.name}:</strong> {desc[index]?.description}
          </div>
        ))}
      </div>
    );
  };

  //JIKA DATANYA ADA 2
  renderDescriptionsTwo = () => {
    const { selectedHost } = this.props;
    const { data } = this.state;

    const value = selectedHost.value;

    const specificHost = Array.isArray(data)
      ? data.find((item) => item.host.hostid === value)
      : null;

    const graphId = specificHost ? specificHost.graph.graphid : null;

    const specificGraph = Array.isArray(this.state.data)
      ? this.state.data.find((item) => item.graph.graphid === graphId)
      : null;

    const items =
      specificGraph && Array.isArray(specificGraph.graph.items)
        ? specificGraph.graph.items
        : [];

    const desc = [
      {
        description:
          "Metrik yang menunjukkan jumlah data yang dikirim melalui antarmuka dalam bentuk bit per detik (bps).",
      },
      {
        description:
          "Metrik ini memberikan gambaran tentang seberapa banyak data yang masuk melalui antarmuka jaringan dalam suatu periode waktu tertentu.",
      },
    ];

    return (
      <div>
        {items.map((item, index) => (
          <div key={index}>
            <strong>{item.name}:</strong> {desc[index]?.description}
          </div>
        ))}
      </div>
    );
  };

  handleDownloadWord = () => {
    const chartInstance = this.chartRef;

    if (!chartInstance) {
      console.error("Chart instance not found.");
      return;
    }

    const imgData = chartInstance.toBase64Image();

    const { selectedHost } = this.props;
    const value = selectedHost.label;

    const currentDate = new Date();
    const options = { day: "numeric", month: "long", year: "numeric" };
    const formattedDate = currentDate.toLocaleDateString("id-ID", options);

    const chartData = this.createChart();
    const analysisResults = this.analyzeChartData(chartData.graph);

    const analysisParagraphs = analysisResults.map(
      (result) =>
        new Paragraph({
          spacing: { after: 80 },
          children: [
            new TextRun({
              text: `Grafik ${result.label}: Rata-rata ${result.average} (`,
              font: "Arial",
              size: 20,
            }),
            new TextRun({
              text: result.status,
              font: "Arial",
              size: 20,
              bold: true,
            }),
            new TextRun({
              text: `)`,
              font: "Arial",
              size: 20,
            }),
          ],
        })
    );

    let paragraphText;
    if (this.allGood(analysisResults)) {
      paragraphText =
        "Traffic network yang berada dalam kondisi baik menunjukkan bahwa aliran data berjalan lancar dengan tingkat penggunaan bandwidth yang rendah. Hal ini mengindikasikan bahwa jaringan dapat menangani beban data dengan efisien, tanpa ada kemacetan atau penurunan kinerja yang signifikan. Kondisi ini sangat ideal, karena sistem memiliki kapasitas yang cukup untuk menangani trafik jaringan yang lebih tinggi di masa depan tanpa menimbulkan masalah. Secara keseluruhan, sistem jaringan berfungsi optimal dan siap untuk mendukung kebutuhan data yang lebih besar.";
    } else if (this.allBad(analysisResults)) {
      paragraphText =
        "Traffic network yang berada dalam kondisi buruk menunjukkan bahwa aliran data tidak berjalan dengan lancar, seperti kemacetan atau penggunaan bandwidth yang tinggi secara konsisten. Kondisi ini dapat mengarah pada penurunan kinerja jaringan, dengan kemungkinan terjadinya latensi, penundaan pengiriman data, atau bahkan kegagalan koneksi. Hal ini mengindikasikan bahwa jaringan tidak dapat menangani beban yang ada dengan efisien, dan tindakan segera diperlukan untuk mendiagnosis penyebabnya, seperti memeriksa konfigurasi perangkat jaringan, mengidentifikasi potensi gangguan, atau menambah kapasitas bandwidth untuk mengatasi masalah.";
    } else if (this.allIdle(analysisResults)) {
      paragraphText =
        "Traffic network yang berada dalam keadaan idle menunjukkan bahwa tidak ada aliran data yang signifikan melalui jaringan pada saat ini. Hal ini bisa terjadi pada sistem yang sedang tidak aktif atau saat tidak ada aktivitas yang memerlukan transfer data. Meskipun tidak berbahaya, kondisi ini menandakan bahwa kapasitas jaringan tidak dimanfaatkan sepenuhnya. Mungkin ada peluang untuk mengoptimalkan penggunaan bandwidth dengan menjalankan tugas atau proses yang memanfaatkan jaringan, agar sistem tetap efisien dan siap untuk menangani beban data di masa mendatang.";
    } else if (
      this.someGood(analysisResults) &&
      this.someIdle(analysisResults)
    ) {
      paragraphText =
        "Traffic network menunjukkan bahwa jaringan berada dalam keadaan idle, dengan sedikit atau tanpa aliran data yang terjadi. Namun, jaringan dalam kondisi baik, dengan kapasitas yang cukup untuk menangani trafik lebih tinggi jika diperlukan. Kondisi ini menunjukkan bahwa meskipun tidak ada aktivitas yang memanfaatkan bandwidth saat ini, sistem siap menangani beban data yang lebih besar di masa depan tanpa masalah. Meskipun tidak ada pengaruh langsung pada kinerja, ini memberikan kesempatan untuk memanfaatkan kapasitas jaringan secara lebih efisien jika ada kebutuhan mendatang.";
    } else if (
      this.someBad(analysisResults) &&
      this.someIdle(analysisResults)
    ) {
      paragraphText =
        "Traffic network menunjukkan keadaan idle dengan sedikit atau tanpa aliran data, namun jaringan dalam kondisi buruk dengan kemungkinan kemacetan atau penggunaan bandwidth yang tinggi saat ada aktivitas. Meskipun saat ini jaringan tidak aktif, kondisi ini mengindikasikan bahwa jaringan mungkin mengalami masalah yang dapat mempengaruhi kinerja saat digunakan. Meskipun saat ini tidak ada trafik yang signifikan, penting untuk segera mengevaluasi dan mengatasi masalah jaringan untuk menghindari penurunan kinerja saat aktivitas meningkat di masa mendatang.";
    } else if (
      this.someGood(analysisResults) &&
      this.someBad(analysisResults) &&
      this.someIdle(analysisResults)
    ) {
      paragraphText =
        "Traffic network menunjukkan kondisi yang kompleks. Meskipun sebagian besar waktu jaringan dalam keadaan idle dengan sedikit atau tanpa aliran data, ada indikasi bahwa saat jaringan digunakan, terjadi masalah seperti kemacetan atau penggunaan bandwidth yang tinggi (Bad). Namun, jaringan secara keseluruhan masih dalam kondisi baik (Good), dengan kapasitas yang cukup untuk menangani lebih banyak trafik. Meskipun tidak ada aliran data yang signifikan pada saat ini, tindakan segera diperlukan untuk mendiagnosis dan mengatasi masalah jaringan yang muncul saat aktivitas meningkat, agar kinerja sistem tetap optimal dan stabil.";
    }

    this.convertImageToBase64(image).then((base64Image) => {
      const doc = new Document({
        sections: [
          {
            properties: {},
            children: [
              // COVER PAGE
              new Paragraph({
                spacing: {
                  after: 500,
                },
                alignment: AlignmentType.RIGHT,
                children: [
                  new ImageRun({
                    data: base64Image,
                    transformation: { width: 250, height: 50 },
                  }),
                ],
              }),

              new Paragraph({
                spacing: {
                  after: 2000,
                },
                alignment: AlignmentType.LEFT,
                children: [
                  new TextRun({
                    text: "Semi-Annual Report Maintenance",
                    font: "Arial",
                    size: 60,
                    bold: true,
                  }),
                ],
              }),
              new Paragraph({
                spacing: {
                  after: 4000,
                },
                alignment: AlignmentType.LEFT,
                children: [
                  new TextRun({
                    text: "E-Office",
                    font: "Arial",
                    size: 40,
                    bold: true,
                  }),
                ],
              }),
              new Paragraph({
                spacing: {
                  after: 200,
                },
                alignment: AlignmentType.LEFT,
                children: [
                  new TextRun({
                    text: formattedDate,
                    font: "Arial",
                    size: 20,
                    bold: true,
                  }),
                ],
              }),
              new Paragraph({
                spacing: {
                  after: 200,
                },
                alignment: AlignmentType.LEFT,
                children: [
                  new TextRun({
                    text: "Kementerian Investasi dan Hilirisasi/BKPM",
                    font: "Arial",
                    size: 20,
                    bold: true,
                  }),
                ],
              }),

              new Paragraph({
                alignment: AlignmentType.LEFT,
                children: [
                  new TextRun({
                    text: "Infrastructure System",
                    font: "Arial",
                    size: 20,
                    italics: true,
                  }),
                ],
              }),

              // PAGE BREAK
              new Paragraph({
                children: [],
                pageBreakBefore: true,
              }),

              // SECOND PAGE
              new Paragraph({
                spacing: {
                  after: 80,
                },
                alignment: AlignmentType.CENTER,
                children: [
                  new TextRun({
                    text: "HEALTH CHECK & UTILIZATION SUMMARY",
                    font: "Arial",
                    size: 25,
                    bold: true,
                  }),
                ],
              }),
              new Paragraph({
                spacing: {
                  after: 80,
                },
                alignment: AlignmentType.CENTER,
                children: [
                  new TextRun({
                    text: "Semi-Annual Average Traffic Network",
                    font: "Arial",
                    size: 25,
                    bold: true,
                  }),
                ],
              }),
              new Paragraph({
                spacing: {
                  after: 500,
                },
                alignment: AlignmentType.CENTER,
                children: [
                  new TextRun({
                    text: "Period Last 6 Month",
                    font: "Arial",
                    size: 20,
                  }),
                ],
              }),

              new Paragraph({
                children: [
                  new TextRun({
                    text: `Host ${value}`,
                    font: "Arial",
                    color: "000000",
                    size: 20,
                    bold: true,
                  }),
                ],
              }),

              new Paragraph({
                children: [],
              }),

              new Paragraph({
                children: [
                  new ImageRun({
                    data: imgData,
                    transformation: { width: 650, height: 400 },
                  }),
                ],
              }),

              new Paragraph({
                children: [],
              }),

              new Paragraph({
                children: [
                  new TextRun({
                    text: "Information :",
                    font: "Arial",
                    color: "000000",
                    size: 25,
                    bold: true,
                  }),
                ],
              }),

              new Paragraph({
                children: [],
              }),

              ...this.getCpuInfoParagraphs(),

              new Paragraph({
                children: [],
                pageBreakBefore: true,
              }),

              new Paragraph({
                spacing: { after: 80 },
                alignment: AlignmentType.LEFT,
                children: [
                  new TextRun({
                    text: "Analysis & Condition :",
                    font: "Arial",
                    size: 23,
                    bold: true,
                  }),
                ],
              }),

              new Paragraph({
                children: [],
              }),

              ...analysisParagraphs,

              new Paragraph({
                spacing: { after: 200 },
                children: [],
              }),

              new Paragraph({
                spacing: { after: 80 },
                alignment: AlignmentType.LEFT,
                children: [
                  new TextRun({
                    text: "Conclusion :",
                    font: "Arial",
                    size: 23,
                    bold: true,
                  }),
                ],
              }),

              new Paragraph({
                children: [],
              }),

              new Paragraph({
                spacing: { after: 80 },
                alignment: AlignmentType.JUSTIFIED,
                children: [
                  new TextRun({
                    text: paragraphText,
                    font: "Arial",
                    size: 20,
                  }),
                ],
              }),
            ],
          },
        ],
      });

      Packer.toBlob(doc).then((blob) => {
        saveAs(blob, "report-maintenance-traffic-network-last-6-month.docx");
      });
    });
  };

  allGood = (analysisResults) => {
    return analysisResults.every((result) => result.status === "Good");
  };

  allBad = (analysisResults) => {
    return analysisResults.every((result) => result.status === "Bad");
  };

  allIdle = (analysisResults) => {
    return analysisResults.every((result) => result.status === "Idle");
  };

  someGood = (analysisResults) => {
    return analysisResults.some((result) => result.status === "Good");
  };

  someBad = (analysisResults) => {
    return analysisResults.some((result) => result.status === "Bad");
  };

  someIdle = (analysisResults) => {
    return analysisResults.some((result) => result.status === "Idle");
  };

  analyzeChartData = (chartData) => {
    if (!chartData || !chartData.datasets || chartData.datasets.length === 0) {
      return [];
    }

    const { datasets } = chartData;

    const results = datasets.map((dataset, index) => {
      const average =
        dataset.data.reduce((sum, val) => sum + val, 0) / dataset.data.length;

      let status;
      if (average === 0) {
        status = "Idle";
      } else if (average < 500) {
        status = "Good";
      } else {
        status = "Bad";
      }

      return {
        label: dataset.label,
        average: average.toFixed(2),
        status: status,
      };
    });

    return results;
  };

  convertImageToBase64 = (imageUrl) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      fetch(imageUrl)
        .then((res) => res.blob())
        .then((blob) => {
          reader.onloadend = () => resolve(reader.result.split(",")[1]);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
        .catch(reject);
    });
  };

  getCpuInfoParagraphs = () => {
    const { data, dataHistory } = this.state;
    const { selectedHost } = this.props;

    if (!selectedHost || !Array.isArray(data)) return [];

    const value = selectedHost.value;
    const specificHost = data.find((item) => item.host.hostid === value);
    const graphId = specificHost ? specificHost.graph.graphid : null;
    const specificGraph = data.find((item) => item.graph.graphid === graphId);
    const items =
      specificGraph && Array.isArray(specificGraph.graph.items)
        ? specificGraph.graph.items
        : [];

    const specificHistory = dataHistory.find(
      (item) => item.host.hostid === value
    );
    const graphIdHistory = specificHistory
      ? specificHistory.graph.graphid
      : null;
    const specificGraphHistory = dataHistory.find(
      (item) => item.graph.graphid === graphIdHistory
    );
    const itemsHistory =
      specificGraphHistory && Array.isArray(specificGraphHistory.graph.items)
        ? specificGraphHistory.graph.items
        : [];

    return items.map((item, index) => {
      const historyItem = itemsHistory.find(
        (historyItem) => historyItem.itemid === item.itemid
      );
      return new Paragraph({
        spacing: {
          after: 80,
        },
        children: [
          new TextRun({
            text: `${item.name} - `,
            font: "Arial",
            color: "000000",
            size: 20,
          }),
          new TextRun({
            text: "Last:",
            font: "Arial",
            color: "000000",
            size: 20,
            bold: true,
          }),
          new TextRun({
            text: ` ${item.last !== null ? item.last : "0.00"} | `,
            font: "Arial",
            color: "000000",
            size: 20,
          }),
          new TextRun({
            text: "Min:",
            font: "Arial",
            color: "000000",
            size: 20,
            bold: true,
          }),
          new TextRun({
            text: ` ${
              historyItem && historyItem.min !== null ? historyItem.min : "0.00"
            } | `,
            font: "Arial",
            color: "000000",
            size: 20,
          }),
          new TextRun({
            text: "Average:",
            font: "Arial",
            color: "000000",
            size: 20,
            bold: true,
          }),
          new TextRun({
            text: ` ${
              historyItem && historyItem.average !== null
                ? historyItem.average
                : "0.00"
            } | `,
            font: "Arial",
            color: "000000",
            size: 20,
          }),
          new TextRun({
            text: "Max:",
            font: "Arial",
            color: "000000",
            size: 20,
            bold: true,
          }),
          new TextRun({
            text: ` ${
              historyItem && historyItem.max !== null ? historyItem.max : "0.00"
            }`,
            font: "Arial",
            color: "000000",
            size: 20,
          }),
        ],
      });
    });
  };

  render() {
    const { loading, errorMessage } = this.state;

    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              {loading ? (
                <div className="text-center">
                  <div>
                    <Spinner
                      style={{
                        width: "3rem",
                        height: "3rem",
                        borderWidth: "0.4rem",
                      }}
                      color="dark"
                    />
                  </div>
                  <div>
                    <span style={{ fontWeight: "bold" }}>
                      Mengambil Data ...
                    </span>
                  </div>
                </div>
              ) : errorMessage ? (
                <Card className="text-center">
                  <br />
                  <CardBody>
                    <h5 className="text-dark">{errorMessage}</h5>
                    <br />
                    <Button color="danger" onClick={this.fetchData}>
                      Muat Ulang
                    </Button>
                  </CardBody>
                </Card>
              ) : (
                <div>
                  <div style={{ textAlign: "right" }}>
                    <Button onClick={this.handleDownloadWord} color="primary">
                      <span className="uil-cloud-download"></span> Unduh Data
                    </Button>
                  </div>
                  <br />
                  <div>
                    <Bar
                      ref={(ref) => (this.chartRef = ref && ref.chartInstance)}
                      data={this.createChart().graph}
                      options={{
                        ...this.createChart().options,
                        responsive: true,
                        plugins: {
                          legend: {
                            position: "top",
                          },
                          tooltip: {
                            callbacks: {
                              label: function (context) {
                                return context.raw + "%";
                              },
                            },
                          },
                        },
                      }}
                    />
                  </div>
                </div>
              )}
            </Col>
          </Row>
          <Row>
            <Col className="col-12">{this.renderNetworkInfo()}</Col>
          </Row>
        </Container>
      </Fragment>
    );
  }
}

export default withRouter(IndexView);
